/* global axios */
import ApiClient from '../ApiClient';

class SlackChannel extends ApiClient {
  constructor() {
    super('slack_indicators', { accountScoped: true });
  }

  create(params) {
    return axios.post(
      `${this.url.replace(this.resource, '')}callbacks/register_slack_account`,
      params
    );
  }
}

export default new SlackChannel();
